/* eslint-disable camelcase */
import { IServerUserInfo } from './Profile'
import { RolesTypesType } from './Roles'

export enum KycTypes {
  'SUCCESS',
  'PENDING',
  'REJECTED',
  'NOT_CONFIRMED',
}

export type KycTypesType = keyof typeof KycTypes

export type KycRejectReason = {
  description: string
  id: number
  language: string
  name: string
}

export enum UserTypes {
  isSelfRegistered = 'self-registered',
  isWithCashier = 'with-cashier',
}

export interface IUser {
  id: number
  balance: number
  currency: string
  bonusBalance: number
  login: string
  username: string
  email: string
  firstName: string
  lastName: string
  role: RolesTypesType
  dateJoined: string
  isSelfRegistered: boolean
  userTypes: UserTypes[]
  parent: number | null
  isDocumentApproved: boolean
  kycVerifyStatus: KycTypesType
  kycRejectReason: null | KycRejectReason
  kycRejectReasonCustom: null | string
}

export interface IServerUser {
  id: number
  balance: string
  balance_currency: string
  bonus_balance: string
  username: string
  email: string
  cpf_document: string | null
  first_name: string
  last_name: string
  is_banned: boolean
  date_joined: string
  last_login: string
  parent: number | null
  role: RolesTypesType
  is_self_registered: boolean
  info?: IServerUserInfo
  needs_document_approve: boolean
  kyc_documents_status: KycTypesType
  kyc_documents_reject_reason: null | KycRejectReason
  kyc_reject_reason_custom: null | string
}
